(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["az-boxnow-cart"]) return;
  try {
    
  (() => {
    function initialiseSection(root) {
      if (root.dataset.azBoxnowInitialised) return;
      root.dataset.azBoxnowInitialised = 'true';
      const updateMapState = () => {
        const map = root.querySelector('iframe[id^="boxnow_map_widget"]');
        const bounds = map?.getBoundingClientRect();
        document.body.classList.toggle('az-locker-map-open', Boolean(bounds?.width && bounds?.height));
      };
      new MutationObserver(updateMapState).observe(root, {
        childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class', 'hidden']
      });
      updateMapState();

      function setCountry() {
        const select = root.querySelector('.tp-box-now-locker-selection__country-select');
        const country = root.dataset.azBoxnowCountry;
        if (select) Array.from(select.options).forEach(option => {
          if (option.value !== 'cy' && option.value !== 'gr') option.remove();
        });
        if (!select || !Array.from(select.options).some(option => option.value === country)) return false;
        if (select.value !== country) {
          select.value = country;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return true;
      }

      if (!setCountry()) {
        const observer = new MutationObserver(() => {
          if (setCountry()) observer.disconnect();
        });
        observer.observe(root, { childList: true, subtree: true });
      }
    }

    function initialise() {
      document.querySelectorAll('[data-az-boxnow-country]').forEach(initialiseSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialise, { once: true });
    } else {
      initialise();
    }
    document.addEventListener('shopify:section:load', initialise);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["az-navigation"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('az-shop-navigation')) {
  class AzizemShopNavigation extends HTMLElement {
    connectedCallback() {
      if (this.abortController) return;
      this.abortController = new AbortController();
      const signal = this.abortController.signal;
      this.hoverQuery = window.matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)');
      this.disclosures = Array.from(this.querySelectorAll('details'));
      this.closeTimers = new Map();
      this.disclosures.forEach((details) => {
        const summary = details.querySelector(':scope > summary');
        summary.setAttribute('aria-expanded', String(details.open));
        details.addEventListener('toggle', () => {
          summary.setAttribute('aria-expanded', String(details.open));
          if (details.open) {
            requestAnimationFrame(() => this.positionPanel(details));
            if (this.classList.contains('az-shop-nav-mobile') && details.classList.contains('az-shop-dropdown')) {
              const other = this.closest('.az-mobile-nav')?.querySelector('.az-mobile-menu');
              if (other) other.open = false;
            }
          } else {
            details.querySelectorAll('details[open]').forEach((child) => { child.open = false; });
          }
        }, { signal });
        if (!details.hasAttribute('data-az-shop-hover')) return;
        details.addEventListener('pointerenter', (event) => {
          if (!this.hoverQuery.matches || event.pointerType !== 'mouse') return;
          clearTimeout(this.closeTimers.get(details));
          details.open = true;
        }, { signal });
        details.addEventListener('pointerleave', (event) => {
          if (!this.hoverQuery.matches || event.pointerType !== 'mouse') return;
          clearTimeout(this.closeTimers.get(details));
          this.closeTimers.set(details, setTimeout(() => {
            details.open = false;
          }, 180));
        }, { signal });
      });
      this.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        const details = event.target.closest('details[open]');
        if (!details || !this.contains(details)) return;
        event.preventDefault();
        event.stopPropagation();
        details.open = false;
        details.querySelector(':scope > summary').focus({ preventScroll: true });
      }, { signal });
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) this.closeAll();
      }, { signal });
      document.addEventListener('pointerdown', (event) => {
        if (!this.contains(event.target)) this.closeAll();
      }, { signal });
      this.hoverQuery.addEventListener('change', () => this.closeAll(), { signal });
      const other = this.closest('.az-mobile-nav')?.querySelector('.az-mobile-menu');
      if (other) other.addEventListener('toggle', () => {
        if (other.open) this.closeAll();
      }, { signal });
    }
    positionPanel(details) {
      if (!details.open || !this.hoverQuery.matches) return;
      const nested = details.classList.contains('az-shop-submenu');
      const panel = details.querySelector(nested ? ':scope > .az-shop-subpanel' : ':scope > .az-shop-panel');
      if (!panel) return;
      const className = nested ? 'az-shop-submenu--flip' : 'az-shop-align-end';
      details.classList.remove(className);
      if (panel.getBoundingClientRect().right > window.innerWidth - 8) details.classList.add(className);
    }
    closeAll() {
      this.closeTimers?.forEach((timer) => clearTimeout(timer));
      this.disclosures?.forEach((details) => { details.open = false; });
    }
    disconnectedCallback() {
      this.closeAll();
      this.abortController?.abort();
      this.abortController = null;
    }
  }
  customElements.define('az-shop-navigation', AzizemShopNavigation);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["azizem-mastic-promo"] && !Shopify.designMode) return;
  try {
    
function azizemMasticExpiry(root) {
  root.querySelectorAll('[data-az-mastic-promo]').forEach(function(promo) {
    function checkExpiry() {
      var remaining = Number(promo.dataset.expiresAt) * 1000 - Date.now();
      if (!Number.isFinite(remaining) || remaining <= 0) {
        promo.hidden = true;
        var section = promo.closest('.az-mastic-section');
        if (section) section.hidden = true;
        return;
      }
      window.setTimeout(checkExpiry, Math.min(remaining, 86400000));
    }
    checkExpiry();
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() { azizemMasticExpiry(document); });
} else {
  azizemMasticExpiry(document);
}
document.addEventListener('shopify:section:load', function(event) { azizemMasticExpiry(event.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
if (!customElements.get('az-purchase-jump')) {
  customElements.define('az-purchase-jump', class extends HTMLElement {
    connectedCallback() {
      this.control = this.querySelector('button, a');
      this.info = document.getElementById(this.dataset.target);
      this.onClick = () => {
        const form = document.getElementById(this.dataset.form);
        const submit = form?.querySelector('[name="add"]');
        if (this.control.tagName === 'BUTTON' && submit && !submit.disabled && submit.getAttribute('aria-disabled') !== 'true') {
          form.requestSubmit(submit);
        } else if (this.control.tagName === 'A' && this.info) {
          this.info.setAttribute('tabindex', '-1');
          this.info.focus({preventScroll: true});
        }
      };
      this.control.addEventListener('click', this.onClick);
      this.sync = () => {
        const form = document.getElementById(this.dataset.form);
        const submit = form?.querySelector('[name="add"]');
        if (this.control.tagName === 'BUTTON') {
          this.control.disabled = !submit || submit.disabled || submit.getAttribute('aria-disabled') === 'true';
          this.control.textContent = submit?.querySelector('span')?.textContent.trim() || this.control.textContent;
        }
        if (submit && submit !== this.observedSubmit && 'IntersectionObserver' in window) {
          this.observer?.disconnect();
          this.observedSubmit = submit;
          this.observer = new IntersectionObserver(entries => {this.hidden = entries[0].isIntersecting;}, {threshold: 0.6});
          this.observer.observe(submit);
        }
      };
      this.sync();
      this.changes = new MutationObserver(this.sync);
      if (this.info) this.changes.observe(this.info, {childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled']});
      const footer = document.querySelector('footer');
      if (footer && 'IntersectionObserver' in window) {
        this.footer = new IntersectionObserver(entries => {this.style.visibility = entries[0].isIntersecting ? 'hidden' : '';});
        this.footer.observe(footer);
      }
    }
    disconnectedCallback() {
      this.observer?.disconnect();this.footer?.disconnect();this.changes?.disconnect();
      this.control?.removeEventListener('click', this.onClick);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
